import { Vue,Component,Emit,Prop,Watch} from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import { toCamel } from 'snake-camel';
import List from '@/assets/common/List/List.vue';
import { Crop, CropFamic } from '@/types/Component';
import SelectCropModal from '@/assets/common/Modal/SelectCropModal/SelectCropModal.vue';
import SelectCropFamicModal from '@/assets/common/Modal/SelectCropFamicModal/SelectCropFamicModal.vue';


type Seedling = {
    id: string;
    name: string;
    crop: Crop;
    cropFamic: CropFamic;
    tenantId: string;
    tenantName: string;
    memo: string;
    isHidden: boolean;
    isActive: boolean;
}

type SeedlingsGet = {
    seedlings: Seedling[];
}

export type Item = {
    id: string;
    name: string;
    isActive: boolean;
    producerId: string
}

export type ProducerItem = {
    producerId: string;
    producerName: string;
    isOpen: boolean;
    seedlings: Item[];
};

export interface ProducerSeedlingsGroup {
    producerId: string;
    producerName: string;
    producerTenantId: string;
    isOpen: boolean;
    seedlings: Seedling[];
}

type ProducersDetails = {
    producerId: string;
    producerName: string;
}[]

type Producers = {
    pdId: string;
    pdName: string;
    pdNo: string;
    dateOfBirth: string;
}

type ProducersTenantDetails = {
    tenantId: string;
    tenantName: string;
    authority: string;
}
type ProducersGet = {
    producers: Producers[];
}

@Component({
    components: {
        Modal,
        Thumbnail,
        List,
        SelectCropModal,
        SelectCropFamicModal
    }
})
export default class SeedlingModal extends Vue {

    @Prop() 
    isShowSeedlingModal!: boolean

    private list: any | null = null
    private title = this.isPesticidePlan ? '生産者/品種（種苗）' : '品種（種苗）';
    private baseUrl = '/seedlings';
    private clientBaseUrl = '/master/seedlings'
    private seedlings!: Seedling[]
    private withHidden = false
    private isLoading = false
    private allSeedlings: Seedling[] = []
    private headerTitle = ""
    private selectedSeedling!: Seedling
    private seedlingId = ""
    private seedlingName = ""
    private seedlingMemo = ""
    private isHidden = false
    private showCropsFamicModal = false
    private selectedCropFamic: CropFamic | null = null
    private dataHeight = { height: '0px' }
    private searchText = ''
    private alteredSeedlings = false
    private items: Item[] | ProducerItem[] = [];
    private tempSelectedProducerId: string | null = null;
    private producerId = ''
    private selectedItem = "";
    private producerseedlings: ProducerSeedlingsGroup[] = []
    private originalItems: Item[] | ProducerItem[] = [];
    private producersUrl = '/producers'
    private tempSelectedProducerTenantId: string | null = null;
    private producersList: Producers[] = []
    private producersTenantList: ProducersTenantDetails[] = []
    private selectedProducerId: string | null = null;
    private disableSelectTenantAndProducer = false
    
    private hiddenSwitchbtn = false;
    // 品目一覧取得
    private cropsFamic: CropFamic[] = []

    @Prop()
    private id!: string

    @Prop()
    private pdTenantId!: string

    @Prop()
    private pdName!: string

    @Prop()
    isNewSeedling!: boolean

    private created() {
        if (this.isPesticidePlan) {
            this.getSeedlingsByProducers();
        } else {
            this.getSeedlings(this.withHidden)
        }
    }

     public get isSeedlingDisabled(): boolean {
        return this.isPesticidePlan ? !this.tempSelectedProducerId || !this.tempSelectedProducerTenantId : false;
    }

    @Watch('isShowSeedlingModal')
    private onIsShowSeedlingModalChange(newVal: boolean) {
        if(this.isPesticidePlan){
            this.getSeedlingsByProducers()
        } else {
            this.getSeedlings(false)
        }
        if(this.isNewSeedling){
            this.createSeedlings(false)
        }
        if (this.isPesticidePlan) {
            this.getProducers()
            this.getProducersTenant()
        }
    }

    @Watch('isShowSeedlingModal')
    onModalVisibilityChanged(val: boolean) {
        this.$emit('update-inert', val)
    }


    @Watch('showCropsFamicModal')
    private onChangeVisibilityCropFamicModal(val:boolean) {
        this.$emit('seedling-cropFamic-inert',val);
    }

    get isPesticidePlan() : boolean {
        return this.$store.getters.loginUser.isPesticidePlan;
    }

    get pesticidePlanProducer() : boolean {
        return this.$store.getters.loginUser.pesticidePlanProducer;
    }

    private getSeedlings(withHidden: boolean) {
        this.list = null
        this.isLoading = true
        const query = [`with_hidden=${withHidden}`];
        if (this.pdTenantId !== undefined && this.pdTenantId !== '') {
            query.push(`tenant_id=${this.pdTenantId}`);
        }
        const url = `${this.baseUrl}?${query.join('&')}`;

        this.$apiClient.doRequest('get', url).then(ret => {
            this.seedlings = (toCamel(ret) as SeedlingsGet).seedlings as Seedling[];
            this.allSeedlings = [...this.seedlings];
            this.items = this.seedlings as unknown as Item[]
            this.originalItems = [...this.items];
            this.isActive(this.seedlingId);
            if(this.selectedItem){
                this.sendItem(this.selectedItem,false,this.tempSelectedProducerId ?? "");
            }
            this.doSearch();
        }).finally(() => {
            this.list = List;
            this.isLoading = false;
        });
    }

    private async getSeedlingsByProducers() {
        this.isLoading = true;
        await this.$apiClient.doRequest('get', `${this.baseUrl}/groupedByProducer?with_hidden=${this.withHidden}`)
        .then((ret) => {
            ret.forEach((producer: any) => {
                if (Array.isArray(producer.seedlings)) {
                    producer.seedlings.sort((a: any, b: any) =>
                        a.name.localeCompare(b.name, 'ja-JP')
                    );
                }
            });
            const updatedProducers = this.preserveIsOpenState(ret, this.producerseedlings);
            this.producerseedlings = updatedProducers;
            this.items = this.producerseedlings as unknown as ProducerItem[];
            this.originalItems = [...this.items];
            if(this.selectedItem){
                this.sendItem(this.selectedItem, false, this.tempSelectedProducerId ?? "");
            }
            this.doSearch()
        })
        .finally(() => {
            this.isLoading = false;
        });
    }

    private preserveIsOpenState(newProducers: any[], oldProducers: any[]) {
        return newProducers.map((newProducer) => {
            const oldProducer = oldProducers.find(
                (p) => p.producerId === newProducer.producerId
            );
        
            return {
                ...newProducer,
                isOpen: oldProducers.length === 0 ? true : oldProducer?.isOpen ?? false,
            };
        });
    }

    private isProducerItemList(items: (Item | ProducerItem)[]): items is ProducerItem[] {
        return items.length > 0 && 'seedlings' in items[0];
    }

    private async sendItem(itemId: string, flag:boolean, producerId?: string): Promise<void> {
        if (itemId === this.selectedItem && flag === true) {
            return;
        }
        this.inputChangedCheck()
        if(this.alteredSeedlings == false){
            if (!this.isProducerItemList(this.items)) {
                (this.items as Item[]).forEach(item => {
                    this.$set(item, 'isActive', item.id === itemId)
                })
            } else {
            (this.items as ProducerItem[]).forEach(producer => {
                    producer.seedlings.forEach(field => {
                        this.$set(
                            field,
                            'isActive',
                            field.id === itemId && producer.producerId === producerId
                        )
                    })
                })
            }
            await this.setSeedlings(itemId, flag, producerId ?? "");
        }else{
            this.hiddenSwitchbtn = false
        }
    }


    private openCropsFamicModal() {
        this.showCropsFamicModal = true
    }

    private handleProducerToggle(toggledProducer: any) {
        this.producerseedlings = this.producerseedlings.map(producer => {
            if (producer.producerId === toggledProducer.producerId) {
                return { ...toggledProducer };
            }
            return producer;
        });
    }

    private saveCropsFamicModal(cropFamic: CropFamic | null) {
        this.selectedCropFamic = cropFamic ?? {
            id: "",
            name: "",
            hiragana: ""
        };
        this.showCropsFamicModal = false;
        this.inputChanged()
    }

    private cropsFamicModalCancel() {
        this.showCropsFamicModal = false
    }

    private toggleHiddenItems() {
        this.hiddenSwitchbtn = true
        if (this.isPesticidePlan) {
            this.getSeedlingsByProducers();
        } else {
            this.getSeedlings(this.withHidden)
        }
    }

    private createSeedlings(flag:boolean) {
        if (this.isPesticidePlan) {
            this.getProducers()
        }
        else {
            this.getProducerDetails();
        }
        this.inputChangedCheck()
        if(this.alteredSeedlings==false){
        this.headerTitle = "新規品種（種苗）"
        this.seedlingId = "create"
        this.seedlingName = ""
        this.seedlingMemo = ""
        this.isHidden = false
        this.selectedCropFamic = null
        this.tempSelectedProducerTenantId = null
        this.selectedProducerId = null
        this.tempSelectedProducerId = null;
        this.producersTenantList = []
        this.selectedItem ="";
        this.disableSelectTenantAndProducer = false
        this.isActive(this.seedlingId);
        if(flag){
            this.openSideBar();
        }
        if (this.isProducerItemList(this.items)) {
            (this.items as ProducerItem[]).forEach(producer => {
                producer.seedlings.forEach(field => {
                    field.isActive = false;
                });
            });
            } else if (Array.isArray(this.items)) {
                (this.items as Item[]).forEach(field => {
                    field.isActive = false;
                });
            }
        }
    }

    private isActive(id: string) {
        this.seedlingId = id;
        this.seedlings?.forEach((seedling: any) => {
            seedling.isActive = seedling.id === id;
        });
    }      

    private async setSeedlings(id: string, flag:boolean, producerId: string, ) {
        this.selectedItem = id;
        this.producerseedlings.forEach((producer: any) => {
            producer.seedlings.forEach((item: any) => {
                item.isActive = item.id === id;
            });
        });
        const seedlings = this.producerseedlings.flatMap(group => group.seedlings).find(field => field.id === id);
        this.tempSelectedProducerTenantId = seedlings?.tenantId ?? null
        if (this.alteredSeedlings === false) {
            this.getProducers();
            this.tempSelectedProducerId = producerId ? producerId : this.tempSelectedProducerId;
            this.producerId = this.tempSelectedProducerId ?? "";
            await this.$apiClient.doRequest("get",`/seedlings/${id}?producerId=${this.tempSelectedProducerId}&tenant_id=${this.tempSelectedProducerTenantId}`).then((ret: any) => {
            this.selectedSeedling = toCamel(ret) as Seedling;
            this.headerTitle = "品種（種苗）情報"
            this.seedlingId = ret.id;
            this.seedlingName = ret.name;
            this.seedlingMemo = ret.memo;
            this.isHidden = ret.is_hidden;
            this.disableSelectTenantAndProducer = ret.existsWithPlanting
            this.selectedCropFamic = ret.cropFamic;
            this.selectedProducerId = this.isPesticidePlan
            ? ret.producers?.[0]?.producerId
            : null;
            this.tempSelectedProducerId = this.selectedProducerId;
            this.tempSelectedProducerTenantId = this.selectedSeedling.tenantId;
            this.pdTenantId = this.selectedSeedling.tenantId
            this.producersTenantList = this.selectedSeedling.tenantId
                ? [{ tenantId: this.selectedSeedling.tenantId, tenantName: this.selectedSeedling.tenantName ?? this.selectedSeedling.tenantId, authority: 'OWNER' }]
                : []
            this.alteredSeedlings = false;
            this.$nextTick(() => {
                this.autoResizeTextarea();
            });
            if(flag){
                this.openSideBar();
            }
        })
        .catch((error) => {
            console.error("Seedling fetch error:", error);
        });
        }
    }

    private switchDisplay() {
        if (!window.confirm(`${this.selectedSeedling.name}を${ this.isHidden ? '表示状態に戻します' : '非表示にします' }。よろしいですか？`)){
            return
        }
        this.hiddenSwitchbtn = true;

        this.isLoading = true

        const query: string[] = [];

            if (this.pdTenantId !== undefined && this.pdTenantId !== '') {
            query.push(`tenant_id=${this.pdTenantId}`);
            }
            query.push(`is_hidden=${!this.isHidden}`);

            const url = `${this.baseUrl}/${this.seedlingId}/display?${query.join('&')}`;

            this.$apiClient.doRequest('put', url).then(() => {
            this.isHidden = !this.isHidden;
            if (this.isPesticidePlan) {
                this.getSeedlingsByProducers();
            } else {
                this.getSeedlings(this.withHidden)
            }
            this.$toasted.success(this.isHidden ? '非表示に変更しました。' : '表示に変更しました。')
        })
        .catch(() => {
            this.$toasted.error('変更に失敗しました。')
        })
        .finally(() => {
            this.isLoading = false
        })
    }
    deleteSeedling(){ 
        const confirm = window.confirm('削除しますか？')

        this.isLoading = true
        if(confirm) {
            this.$apiClient.doRequest('delete', `${this.baseUrl}/${this.seedlingId}`)
                .then((response: any) => {
                    if (response) {
                        alert(response);
                        this.isLoading = false;
                        return;
                    }
                    this.$toasted.success('削除しました。')
                    this.alteredSeedlings = false
                    if (this.isPesticidePlan) {
                        this.getSeedlingsByProducers();
                    } else {
                        this.getSeedlings(this.withHidden)
                    }
                    this.createSeedlings(false);
                })
                .catch(() => {
                    this.$toasted.error('削除に失敗しました。')
                })
        } else {
            this.$toasted.success('削除がキャンセルされました。')
            this.isLoading = false
        }
    }
    private cancelEdit() {
        if (this.alteredSeedlings) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
        this.hiddenSwitchbtn = false
        }
        this.alteredSeedlings = false
        if(this.seedlingId !== 'create') {
            this.setSeedlings(this.seedlingId, false, this.producerId, )
        } else {
            this.createSeedlings(false)
        }
    }

    private submit(isHiddenUpdate: boolean) {
        const errmsg: string[] = []

        if (this.isPesticidePlan) {
            if (!this.tempSelectedProducerId) {
                errmsg.push("生産者を選択してください");
            }
            if (this.tempSelectedProducerId && !this.tempSelectedProducerTenantId) {
                errmsg.push("生産者のテナントを選択してください");
            }
        }

        // 名前の入力
        if(!this.seedlingName.trim()) {
            errmsg.push("品種（種苗）名を入力してください")
        }
        // 名前の長さ
        if(this.seedlingName.length > 100) {
            errmsg.push(`品種（種苗）名は100文字以内で入力してください（現在は${this.seedlingName.length}文字）`)
        }
        if(!this.selectedCropFamic?.id) {
            errmsg.push("品目（作目）を選択してください")
        }
        // メモ
        if(this.seedlingMemo && this.seedlingMemo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.seedlingMemo.length}文字）`)
        }
        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }

        this.isLoading = true
        const params = {
            producer_id : this.tempSelectedProducerId,
            producer_tenant_id : this.tempSelectedProducerTenantId ?? null,
            name: this.seedlingName.trim(),
            crop_id:  this.selectedCropFamic?.id != "" ? this.selectedCropFamic?.id : null,
            crop_famic_id : this.selectedCropFamic?.id != "" ? this.selectedCropFamic?.id : null,
            memo: this.seedlingMemo.trim()
        }

        if (this.seedlingId === "create") {
            const query: string[] = [];
        if (this.pdTenantId !== undefined && this.pdTenantId !== '') {
            query.push(`tenant_id=${this.pdTenantId}`);
        }
        // const url = query.length > 0 ? `${this.baseUrl}?${query.join('&')}` : this.baseUrl;

        this.$apiClient.doRequest("post", this.baseUrl, params).then((ret) => {
                if (this.isPesticidePlan) {
                    this.getSeedlingsByProducers();
                } else {
                    this.getSeedlings(this.withHidden)
                }
                this.alteredSeedlings = false
                this.sendItem(ret.id, false,this.tempSelectedProducerId ?? "");
                this.isActive((ret as Seedling).id);
                this.$toasted.success('保存しました。')
                if (this.isNewSeedling) {
                    this.$emit('createdSeedlingId', ret.id ?? null);
                    this.$emit('update:isShowSeedlingModal', false);
                }
            })
            .catch(() => {
                this.$toasted.error('保存に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
                this.alteredSeedlings = false;
            })
        } else {
            const result = isHiddenUpdate ? true : window.confirm("内容を上書きして保存します。よろしいですか。")
            if(!result) {
                this.isLoading = false
                return false;
            }
            const query: string[] = [];
            if (this.pdTenantId !== undefined && this.pdTenantId !== '') {
            query.push(`tenant_id=${this.pdTenantId}`);
            }
            const url = query.length > 0
            ? `${this.baseUrl}/${this.seedlingId}?${query.join('&')}`
            : `${this.baseUrl}/${this.seedlingId}`;

            this.$apiClient.doRequest("put", `${this.baseUrl}/${this.seedlingId}`, params).then((res) => {
                if (this.isPesticidePlan) {
                    this.getSeedlingsByProducers();
                } else {
                    this.getSeedlings(this.withHidden)
                }
                this.sendItem(res.id,false ,this.tempSelectedProducerId ?? "");
                this.$toasted.success('変更を保存しました。')
            })
            .catch(() => {
                this.$toasted.error('変更に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
        }
        this.searchText = ''
        this.alteredSeedlings = false
    }
    @Emit('inputChanged')
    private inputChanged(){
        if(this.alteredSeedlings ==false){
            this.alteredSeedlings = true
        }
    }

    private toggleProducer(selectedProducer: ProducerItem) {
        selectedProducer.isOpen = !selectedProducer.isOpen;
        return selectedProducer;
    }

    private onProducerSelect() {
        this.selectedProducerId = this.tempSelectedProducerId;
    }

    private async onProducerChange() {
        this.tempSelectedProducerTenantId = null
        await this.getProducersTenant();
        if (!this.isPesticidePlan) {
            await this.getProducerDetails()
        }
    }

    private getProducers() {
        this.$apiClient
            .doRequest('get', `${this.producersUrl}`)
            .then(res => {
                this.producersList = (toCamel(res) as ProducersGet).producers as Producers[];
            })
            .catch(error => {
                console.error('Failed to fetch producers:', error);
            });
    }

    private async getProducersTenant() {
        this.$apiClient
            .doRequest('get', `${this.producersUrl}/producers_tenant/${this.tempSelectedProducerId}`)
            .then(res => {
                this.producersTenantList = toCamel(res.producersTenant) as ProducersTenantDetails[];
                if (this.producersTenantList.length === 1) {
                    this.tempSelectedProducerTenantId = this.producersTenantList[0].tenantId
                }
            })
            .catch(error => {
                console.error('Failed to fetch producers:', error);
            });
    }

    private async getProducerDetails() {
        this.selectedProducerId = this.isPesticidePlan ? this.tempSelectedProducerId : this.$store.getters.loginUser.id;
        this.$apiClient
            .doRequest('get', `${this.producersUrl}/${this.selectedProducerId}`)
            .then(res => {
                this.producerId = res.pdId;
            })
            .catch(error => {
                console.error('Failed to fetch producer:', error);
            });
    }

    closeModal(){
         if (this.alteredSeedlings && !window.confirm('変更内容を破棄します。よろしいですか？')) {
        return; 
        }
        this.hiddenSwitchbtn = false
        this.alteredSeedlings = false;
        this.$emit('update:isShowSeedlingModal', false);
        this.seedlingId = "";
        this.selectedCropFamic = null;
        this.searchText = "";
        this.withHidden = false;
        this.producerseedlings = [];
        this.originalItems = [];
        this.items = []
        this.seedlings = []
        this.selectedItem ="";
         if(this.pdTenantId !== undefined && this.pdTenantId !== '') {
                this.alteredSeedlings = false
         }
    }

    @Watch('searchText')
    private doSearch(): void {
        const search = this.searchText.trim();

        if (!search) {
            if (this.isProducerItemList(this.originalItems)) {
                this.items = [...(this.originalItems as ProducerItem[])];
            } else {
                this.items = [...(this.originalItems as Item[])];
            }
            return;
        }

        if (this.isProducerItemList(this.originalItems)) {
            const filteredProducers = (this.originalItems as ProducerItem[])
                .map(producer => {
                    const isProducerMatch = producer.producerName?.includes(search);
                    const filteredSeedlings = producer.seedlings.filter(seed =>
                        seed.name?.includes(search)
                    );

                    if (isProducerMatch || filteredSeedlings.length > 0) {
                        return {
                            ...producer,
                            seedlings: isProducerMatch
                                ? producer.seedlings
                                : filteredSeedlings,
                            isOpen: producer.isOpen
                        };
                    }

                    return null;
                })
                .filter((p): p is ProducerItem => p !== null);

            this.items = filteredProducers;
        }

        else {
            this.items = (this.originalItems as Item[]).filter(item =>
                item.name?.includes(search)
            );
        }
    }

    openSideBar = () => {
        const isResponsive = window.matchMedia('(max-width: 1000px)').matches;
        if (!isResponsive) {
            return; 
        }
        if(document.body.classList.contains('newsSide')){
            document.body.classList.remove('newsSide')
        }else{
            document.body.classList.add('newsSide')
        }
    }
    inputChangedCheck(){
        if(this.alteredSeedlings==true && this.hiddenSwitchbtn === false){
        const confirm = window.confirm('変更内容を破棄します。よろしいですか？')
        if(confirm){
            this.alteredSeedlings = false
        }
        }
    }
     
    @Watch('seedlingMemo')
    onSeedlingMemoChanged() {
        this.$nextTick(() => {
        this.autoResizeTextarea();
        });
    }

    private autoResizeTextarea() {
        const textarea = this.$refs.autoTextarea as HTMLTextAreaElement;
        if (!textarea) return;
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
    }
}      